import React from 'react';

const Server = ({ servers, selectedServerId, onChange }) => {
  return (
    <div className="cardStyle mb-4">
      <div className="cardHeader">
        <h4 className="smTitle mb-0">Servers</h4>
      </div>

      <div className="cardBody">
        <div className="btnGroup">
          {servers.map((server) => (
            <div key={server.id}>
              <input
                type="radio"
                className="btn-check"
                name="serverRadio"
                id={`server-${server.id}`}
                checked={selectedServerId == server.id}
                onChange={() => onChange(server.id)}
              />

              <label className="radioBtn" htmlFor={`server-${server.id}`}>
                {server.first_name} {server.last_name}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Server;
